module.exports = __webpack_public_path__ + "img/icon-price.50cbc430.svg";